import { config } from "@/config";
import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: config.sentry.enabled,
  dsn: config.sentry.dsn,
  environment: config.sentry.environment,
  release: config.github.sentryRelease,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [config.hosts.api, window.location.origin],
    }),
    Sentry.feedbackIntegration({
      isNameRequired: true,
      autoInject: false,
    }),
  ],
  tracesSampleRate: config.sentry.tracesSampleRate,
  // Replay stays loaded but idle; useTrackUser starts recording once the
  // user is known and the replay gate allows it.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  tracePropagationTargets: [config.hosts.api, window.location.origin],
  beforeSend: (event, hint) => {
    console.error(hint.originalException || hint.syntheticException);
    if (config.sentry.enabled) {
      return event;
    } else {
      console.log(event);
      return null;
    }
  },
});

if (
  navigator.webdriver ||
  window.location.pathname === "/canvas-capture.html"
) {
  Sentry.setTag("automation", "true");
}

export default Sentry;
